var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',{staticClass:"notice",class:_vm.notice.type,attrs:{"columns":{ default: 'auto 1fr' },"custom":""}},[_c('Icon',{staticStyle:{"align-self":"center"},attrs:{"name":_vm.icon,"size":"2"}}),_c('div',[(_vm.notice.title)?_c('strong',[_vm._v(_vm._s(_vm.notice.title))]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.notice.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }